import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
export default class Search {
	static init() {
		this.btnSearchBox = document.querySelector(".search-box");
		this.btnSearch = this.btnSearchBox.querySelector(".search-box .btn-search");
		this.searchInner = this.btnSearchBox.querySelector('.inner');
		if (!this.btnSearch) {
			return;
		}
		this.initSearch();
		GlobalVariables.resizeCallbacks.push(this);
	}

	static initSearch() {
		this.btnSearch.addEventListener('click', (e) => {
			e.preventDefault();
			if (document.body.classList.contains('search-opened')) {
				let lang = this.btnSearch.dataset.lang;
				this.performSearch(lang);
			} else {
				this.openSearch();
			}
		});

		document.querySelector(".search-box .btn-close").addEventListener('click', (e) => {
			e.preventDefault();
			this.closeSearch();
		});
	}

	static openSearch() {
		document.body.classList.add('search-opened');
		document.querySelector(".search-box input[type='search']").focus();

		let searchPosition = this.searchInner.getBoundingClientRect().right;
		let logoWidth = document.querySelector(".header-logo").getBoundingClientRect().right + 15;
		let mainNavWidth = document.querySelector('.nav-main').offsetWidth;

		gsap.to(this.searchInner, {
			width: ( window.innerWidth > 991 ) ? mainNavWidth : searchPosition - logoWidth
		});
	}

	static closeSearch() {
		document.body.classList.remove('search-opened');
		gsap.to(this.searchInner, {
			width: "auto"
		});
	}

	static performSearch(lang) {
		const searchInput = document.querySelector(".search-box input[type='search']");
		const searchQuery = searchInput.value;
		if (searchQuery) {
			if (lang == "fr") {
				window.location.href = `/?s=${searchQuery}`;
			} else {
				window.location.href = `/${lang}/?s=${searchQuery}`;
			}
		}
	}

	static resize(){
		this.closeSearch();
	}

}